// CRM section — pipeline + households + (eventually) per-household account
// pages, conversion analytics, etc.
//
// Sub-routes:
//   /crm            Pipeline & Forecast (default landing)
//   /crm/households Households

import SectionLayout from '../../components/common/SectionLayout';

const ITEMS = [
  { to: '/crm', label: 'Pipeline & Forecast', end: true },
  { to: '/crm/households', label: 'Households' },
];

export default function CRMSection() {
  return <SectionLayout title="CRM" items={ITEMS} />;
}
